import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Using pipe for this evaluation to avoid ExpressionChangedAfterItHasBeenCheckedError when redirecting to the incidents page from another page.

@Pipe({
  name: 'filterHasValue',
  standalone: true,
  pure: true, // ensures Angular only re-evaluates when inputs change
})
export class FilterHasValuePipe implements PipeTransform {
  transform(filterGroup: FormGroup, formControl: string): boolean {
    const control = filterGroup.get(formControl);

    if (!control) {
      return false;
    }

    if (formControl === 'timeperiod') {
      return !!control.get('dateStart')?.value || !!control.get('dateEnd')?.value;
    }

    return !!control.value?.length;
  }
}
